import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link, useLocation } from "react-router-dom";
import { FormContext } from "./../../context/FormContext";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const StepperControl = () => {
    const location = useLocation();
    const [progress, setProgress] = useState(localStorage.getItem('step') || "5%");
    const [currentStep, setCurrentStep] = useState(0);
    const containerRef = useRef(null);
    const { hasValidAddress, hasValidRoofArea, hasValidRoofObstacle } = useContext(FormContext);

    const Steps = [
        {to: '/', label: 'Adresse', ref: useRef(), hidden: false, validation: null},
        {to: '/RoofType', label: 'Dachtyp', ref: useRef(), hidden: false, validation: hasValidAddress},
        {to: '/RoofArea', label: 'Dachfläche', ref: useRef(), hidden: false, validation: hasValidAddress},
        {to: '/RoofObstacles', label: 'Hindernisse', ref: useRef(), hidden: false, validation: hasValidAddress && hasValidRoofArea},
        {to: '/EnergyConsumption', label: 'Jahresverbrauch', ref: useRef(), hidden: false, aliases:['/ElectricCar', '/HeatingPump'], validation: hasValidAddress && hasValidRoofArea && hasValidRoofObstacle},
        {to: '/EnergyCost', label: 'Kosten', ref: useRef(), hidden: false, validation: hasValidAddress && hasValidRoofArea && hasValidRoofObstacle},
        // {to: '/ElectricalBox', label: 'Unterverteilung', ref: useRef(), hidden: false, validation: hasValidAddress && hasValidRoofArea && hasValidRoofObstacle},
    ];

    const Circle = () => {
        return (<div><svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g><circle cx="23.5" cy="19.5" r="13.5" fill="#7D8694"/></g>
        <circle cx="23.5" cy="19.5" r="5.5" fill="#313C44"/>
        <path className="checkmark" d="M2 6.6058L3.26028 7.86667L5.52115 10L13.9994 2" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg></div>
        )
    }

    // figure out current step
    useEffect(() => {
        let currentStep = Steps.findIndex(step => step.to === location.pathname);
        if(currentStep < 0) {
            currentStep = Steps.findIndex(step => step.to === location.pathname || (step.aliases && step.aliases.includes(location.pathname)));
        }
        setCurrentStep(currentStep);
    }, [location]);

    // set progress based of current step
    // if step is hidden we search backwards for the first visible step
    useEffect(() => {

        if (!containerRef.current) return;

        const containerWidth = containerRef.current.offsetWidth;
        const containerRect = containerRef.current.getBoundingClientRect();

        const getRelativeX = (targetRect) => {
            return targetRect.left - containerRect.left + (targetRect.width / 2);
        };

        // if (Steps[currentStep].hidden) {
        //     // search backwards and find first step that is not hidden
        //     const firstVisibleStepBackwards = Steps
        //         .slice(0, currentStep + 1)
        //         .reverse()
        //         .find(step => !step.hidden);
        //     const targetRect = firstVisibleStepBackwards.ref.current.getBoundingClientRect();
        //     const relativeCenterX = getRelativeX(targetRect);
        //     const progress = (relativeCenterX / containerWidth) * 100 + "%";
        //     setProgress(progress);
        // }
        if (currentStep < 0) {
            // search backwards and find first step that is not hidden
            // const firstVisibleStepBackwards = Steps
            //     .slice(0, currentStep + 1)
            //     .reverse()
            //     .find(step => !step.hidden);
            // const targetRect = firstVisibleStepBackwards.ref.current.getBoundingClientRect();
            // const relativeCenterX = getRelativeX(targetRect);
            const progress = "100%";
            setProgress(progress);
        } else if(Steps[currentStep] && Steps[currentStep].ref && Steps[currentStep].ref.current){
            const targetRect = Steps[currentStep].ref.current.getBoundingClientRect();
            const relativeCenterX = getRelativeX(targetRect);
            const progress = (relativeCenterX / containerWidth) * 100 + "%";
            setProgress(progress);
        }
    }, [currentStep]);

    // store progress in local storage for initializtation
    useEffect(() => {
        localStorage.setItem('step', progress);
    }, [progress]);

    const StepperEntry = (props) => {
        const isLinkDisabled = props.validation && !props.validation();
        const handleClick = (e) => {
            if (isLinkDisabled) {
                e.preventDefault();
            }
        };
        return (
            <Col className="px-0">
                <Link
                    to={props.to}
                    onClick={handleClick}
                    ref={Steps[props.index].ref}
                    index={props.index}
                    className={`${buildStepperClasses(props)} ${isLinkDisabled ? 'disabled-link' : ''}`}
                    style={isLinkDisabled ? { opacity: 1.0, cursor: 'not-allowed' } : {}}
                >
                    <span className="d-none d-md-inline">{props.label}</span> {<Circle />}
                </Link>
            </Col>
        );
    }

    const StepperWrapper = (props) => {
        return (<Container><Row>{props.children}</Row></Container>);
    }

    return (
        <div ref={containerRef} className="StepperControl" style={{
            "--progress": `${progress}`
        }}>
            <StepperWrapper>
                {Steps && Steps.filter(step => !step.hidden).map((step, index) => (
                    <StepperEntry key={index} to={step.to} index={index} label={step.label} validation={step.validation} />
                ))}
            </StepperWrapper>
        </div>
    )

    function buildStepperClasses(props){
        const stepClasses = [];

        if(props.index === currentStep)
            stepClasses.push('active');

        if(props.index < currentStep || currentStep < 0)
            stepClasses.push('visited');

        return stepClasses.join(' ');
    }
}

export default StepperControl;